// SICARG MOD 5 — Helpers de visibilidad por sección (overlay).
// Default = permitido. Solo oculta/bloquea cuando la sección está en false.
import { getCurrentAccount } from './permissionsHelper';

export const getSicargPermissions = (user, accountId) => {
  const currentAccount = getCurrentAccount(user || {}, accountId) || {};
  return currentAccount.sicarg_permissions || {};
};

export const sicargCan = (sicargPermissions, section, type) => {
  if (!section) return true;
  const config = (sicargPermissions || {})[section];
  if (!config) return true;
  return config[type] !== false;
};

export const sicargCanView = (sicargPermissions, section) =>
  sicargCan(sicargPermissions, section, 'view');

export const sicargCanEdit = (sicargPermissions, section) =>
  sicargCan(sicargPermissions, section, 'edit');

// SICARG — permiso opt-in para editar un contacto YA EXISTENTE (distinto de
// sicargCan*, que son overlays "todo permitido salvo que se desactive"). Sin
// la key explícita en true, el resultado es false. El admin se resuelve en el
// componente que llama a esto (isAdmin || sicargCanEditExistingContact(...)),
// igual que ya se combina isAdmin con el resto de las restricciones de Contactos.
export const sicargCanEditExistingContact = sicargPermissions =>
  (sicargPermissions?.contacts || {}).edit_existing === true;

// Lista de secciones/acciones controlables (usada por la UI de roles).
export const SICARG_SECTIONS = [
  'new_conversation',
  'search',
  'contacts',
  'reports',
  'campaigns',
  'inboxes',
  'labels',
  'teams',
  'automation',
  'help_center',
  'canned_responses',
  'closures',
  'branding',
];

// Mapa path → sección. Fail-safe: si nada matchea devuelve null (= sin restricción).
const SECTION_PATH_RULES = [
  ['contacts', /\/contacts(\/|$|\?)/],
  ['reports', /\/reports(\/|$|\?)/],
  ['campaigns', /\/campaigns(\/|$|\?)/],
  ['inboxes', /\/settings\/inboxes(\/|$|\?)/],
  ['labels', /\/settings\/labels(\/|$|\?)/],
  ['teams', /\/settings\/teams(\/|$|\?)/],
  ['automation', /\/settings\/automation(\/|$|\?)/],
  ['closures', /\/settings\/closures(\/|$|\?)/],
];

export const sicargSectionForPath = (path = '') => {
  const rule = SECTION_PATH_RULES.find(([, regex]) => regex.test(path));
  return rule ? rule[0] : null;
};
